import { render, staticRenderFns } from "./relation.vue?vue&type=template&id=f91805ce&scoped=true"
import script from "./relation.vue?vue&type=script&lang=js"
export * from "./relation.vue?vue&type=script&lang=js"
import style0 from "./relation.vue?vue&type=style&index=0&id=f91805ce&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f91805ce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\git-new\\ai-business-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f91805ce')) {
      api.createRecord('f91805ce', component.options)
    } else {
      api.reload('f91805ce', component.options)
    }
    module.hot.accept("./relation.vue?vue&type=template&id=f91805ce&scoped=true", function () {
      api.rerender('f91805ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clue/components/relation.vue"
export default component.exports